
export default () => ({
    loading: true,
    entities: [],
    pagination: null,
    scheme: {},
    currentEntity: null
})
